import {
  PlayerPacksHeader,
  PlayerPacksTable
} from '@bo-components/playerPacks';
import { PageBody } from '@library/components/layout/PageBody';

export const PlayerPacksList = () => {
  return (
    <>
      <PlayerPacksHeader />
      <PageBody>
        <PlayerPacksTable />
      </PageBody>
    </>
  );
};
